export enum BARRY_WEBSOCKET_MESSAGE_TYPES {
	STATUS_UPDATE = 'status_update',
	USER_INPUT_REQUIRED = 'user_input_required',
	TASK_COMPLETED = 'task_completed',
	ERROR = 'error',
	ASSISTANT_MESSAGE = 'assistant_message',
	ASSISTANT_MESSAGE_CHUNK = 'assistant_message_chunk',
	ASSISTANT_MESSAGE_COMPLETE = 'assistant_message_complete',
	VISUALIZATION = 'visualization',
	REPORT_STAGE = 'report_stage',
}
